import React, { useState, useEffect } from 'react';
import uiManager from '../../../../config/ui.js';
import PAGES from '../../../data/PagesConstants';
import ListingPageComponent from '../../../components/ListingPageComponent.js';
import { getApi } from '../../../api/endpoints.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import FiltersPartial from './FiltersPartial';
import { useSelector, useDispatch } from "react-redux";
import { selectQueryParams } from "../../../ui/customerListingReducer";
import UiAction from "../../../components/UiAction.js";
import UI_ACTIONS from "../../../data/UiActionConstants.js";
import PaymentModal from './PaymentModal'

const Index = (props) => {
  const defaultHeaderConfig = { disableSort: false };
  const queryParams = useSelector(selectQueryParams);
  const [filtersModel, setFiltersModel] = useState({});
  const [toUpdateRow, setToUpdateRow] = useState(null);

  useEffect(()=>{
    setFiltersModel(queryParams?.filters)
  }, [queryParams])

  const headers  = [
    {
      ...defaultHeaderConfig,
      label: 'ID',
      attr: 'id',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Charging Partner',
      value: ((row) => {
        return <>
          {row.charging_partner?.nomenclature} - {row.charging_partner?.firm?.name}
        </>
      }),
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Amount',
      attr: 'bill_amount',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Voucher Number',
      attr: 'reimbursement_voucher_number',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Service Provider',
      value: ((row) => {
        return <>{row.service_provider?.name}</>
      }),
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Charging Station',
      value: ((row) => {
        return <>{row.charging_stations.map((station) => {
          return <div key={station.id}>{station.serial_no}</div>
          }
        )}</>
      }),
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Generated At',
      attr: 'created_at',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Bill',
      value: ((row) => {
        return <span className='d-flex justify-content-between'>
          <>{row.bill_no}</><br/>
          <>{row.payment_mode}</>
          <><a target="_blank" href={row.bill_file?.url} rel="noreferrer"><FontAwesomeIcon icon={faDownload}/></a></>
          </span>
      }),
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Status',
      attr: 'status',
      disableSort: true
    },
    {
      ...defaultHeaderConfig,
      label: 'Actions',
      value: (row) => {
         return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_electricity_billing.name)}>
            <div style={{ cursor: 'pointer' }} onClick={(e)=>setToUpdateRow(row)}>
              <button className='border'>Settle Claim</button>
            </div>
          </UiAction>
        </div>
      },
      disableSort: true
    },
  ]
  const onViewClick = ()=>{

  }

  return <>
    { toUpdateRow && <PaymentModal updateDetails={toUpdateRow} updateShowState={() => setToUpdateRow(null)}/>}
    <ListingPageComponent
      key={PAGES.ElectricityClaimsListingPage.name}
      uiPage={uiManager.getUiPage(PAGES.ElectricityClaimsListingPage.name)}
      breadcrumbs={[{label: 'Home', url: '/dashboard'}, {label: 'Electricity', url:'/electricity/claims'}, {label: 'Claims'}]}
      listingMutation={getApi('electricityClaims')}
      className="Electricity-claims-listing-page"
      contentHeading="Electricity Claims- Results"
      headers={headers}
      recordsKey="electricity_billings"
      filters={
        <FiltersPartial
          filtersModel={filtersModel}
          setFiltersModel={setFiltersModel}
        />
      }
      searchBy={['ID', 'Charging Partner', 'Voucher Number', 'Service Provider']}
    />
  </>
};

export default Index;



